import './App.css';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import HomeMain from './pages/home-main.js';
import PageServices from './pages/page-services.js';
import PageServicesDetails from './pages/page-services-details.js';
import PortfolioGallery from './pages/portfolio-gallery.js';
import PageContact from './pages/page-contact.js';
import ProjectDetails from './pages/project-details.js';
// import gsap from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// // // import { ScrollSmoother } from 'gsap-trial/ScrollSmoother';

// gsap.registerPlugin(ScrollTrigger);
// gsap.config({ trialWarn: false });
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeMain />} />
        {/* <Route path="/blog-classic" element={<BlogClassic />} />
        <Route path="/blog-details" element={<BlogDetails />} />
        <Route path="/blog-grid-3column" element={<BlogGrid3Columns />} />
        <Route path="/blog-grid-sidebar" element={<BlogGridSidebar />} /> */}
        {/* <Route path="/home-creative-agency" element={<HomeCreativeAgency />} />
        <Route path="/home-digital-agency" element={<HomeDigitalAgency />} /> */}
        <Route path="/home-main" element={<HomeMain />} />
        {/* <Route path="/home-modern-studio" element={<HomeModernStudio />} />
        <Route path="/home-personal" element={<HomePersonal />} />
        <Route path="/page-404" element={<Page404 />} />
        <Route path="/page-about" element={<PageAbout />} />
        
        <Route path="/page-FAQ" element={<PageFAQ />} /> */}
        <Route path="/page-contact" element={<PageContact />} />
        <Route
          path="/page-services-details"
          element={<PageServicesDetails />}
        />
        <Route path="/page-services" element={<PageServices />} />
        {/* <Route path="/page-team" element={<PageTeam />} />
        <Route path="/page-team-details" element={<PageTeamDetails />} />
        <Route path="/portfolio-creative" element={<PortfolioCreative />} />
        <Route
          path="/portfolio-creative-carousel"
          element={<PortfolioCreativeCarousel />}
        /> */}
        <Route path="/project-details" element={<ProjectDetails />} /> 
        <Route path="/portfolio-gallery" element={<PortfolioGallery />} />
        {/* <Route path="/portfolio-grid" element={<PortfolioGrid />} />
        <Route path="/portfolio-masonry" element={<PortfolioMasonry />} />
        */}
        
        {/*        
        {/*
         */}
      </Routes>
    </Router>
  );
}

export default App;
